const maskEmail = (email: string, showTrueStringLength = true) => {
  const accountName = email.split('@')[0];
  const domain = email.split('@')[1];
  const [domainName, ...domainExtension] = domain.split('.');
  if (showTrueStringLength) {
    const accountNameStarred = '*'.repeat(accountName.trim().length - 1);
    const domainNameStarred = '*'.repeat(domainName.trim().length - 1);
    const domainStarred = domain.replace(domainName, domainNameStarred);
    return `${email.trim()[0]}${accountNameStarred}@${domain[0]}${domainStarred}`;
  }
  return `${email?.trim()[0]}***@***.${domainExtension.join('.')}`;
};

export default maskEmail;
